module.exports = __webpack_public_path__ + "img/facebook.c8717de.png";